import React from "react";
import {FormattedMessage} from "react-intl";
import TableRow from "./TableRow";
import Empty from "./Empty";
import classes from "./styles.module.css";

function CountryTop({data}) {
    return (
        <div className={classes.Wrap}>
            {Boolean(data.length) ? (
                <React.Fragment>
                    <table className={`${classes.Table} ${classes.DesktopTable}`}>
                        <thead>
                        <tr>
                            <th className={classes.CellLeft}>
                                <FormattedMessage id="CountryTop.table.country" defaultMessage="Страна"/>
                            </th>
                            <th>
                                <FormattedMessage id="CountryTop.table.turnover" defaultMessage="Оборот"/>
                            </th>
                            <th>
                                <FormattedMessage id="CountryTop.table.transactions" defaultMessage="Транзакции"/>
                            </th>
                            <th>
                                <FormattedMessage id="CountryTop.table.successful" defaultMessage="Успешные"/>
                            </th>
                            <th>
                                <FormattedMessage id="CountryTop.table.declined" defaultMessage="Отклоненные"/>
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {data.map((row, index) => (
                            <TableRow key={index} data={row}/>
                        ))}
                        </tbody>
                    </table>

                    <div className={classes.MobileList}>
                        {data.map((row, index) => (
                            <div className={classes.MobileCard} key={index}>
                                <div className={classes.MobileHeader}>
                                    <span className={classes.MobileCountry}>{row[0]}</span>
                                    <span className={classes.MobileTurnover}>{row[1]}</span>
                                </div>
                                <div className={classes.MobileStats}>
                                    <div>
                                        <span>
                                            <FormattedMessage
                                                id="CountryTop.table.transactions"
                                                defaultMessage="Транзакции"
                                            />
                                        </span>
                                        <strong>{row[2]}</strong>
                                    </div>
                                    <div>
                                        <span>
                                            <FormattedMessage
                                                id="CountryTop.table.successful"
                                                defaultMessage="Успешные"
                                            />
                                        </span>
                                        <strong className={classes.Success}>{row[3]}</strong>
                                    </div>
                                    <div>
                                        <span>
                                            <FormattedMessage
                                                id="CountryTop.table.declined"
                                                defaultMessage="Отклоненные"
                                            />
                                        </span>
                                        <strong className={classes.Decline}>{row[4]}</strong>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </React.Fragment>
            ) : (
                <Empty/>
            )}
        </div>
    );
}

export default CountryTop;



// WEBPACK FOOTER //
// ./src/Components/Charts/CountryTop/index.js